/**
 * Author: Berk Emre Uzun
 * Date: 28.11.2024
 * Purpose: Create customizable smartbanners for mobligo!
 */

class Mobligo {

    createElement = (item) => {
        const { type, styles, classNames, attributes, listeners } = item
        const element = document.createElement(type)
        if (styles) {
            Object.keys(styles).forEach((key) => {
                const value = styles[key];
                element.style[key] = value;
            });
        }
        if (classNames) {
            classNames.forEach((className) => {
                element.classList.add(className);
            });
        }
        if (attributes) {
            Object.keys(attributes).forEach((key) => {
                if (key === 'innerText') {
                    element.innerText = attributes[key];  // Directly set innerText as a property
                } else if (key === 'innerHTML') {
                    element.innerHTML = attributes[key];  // For innerHTML if needed
                } else {
                    element.setAttribute(key, attributes[key]);  // For other attributes
                }
            });
        }
        if (listeners) {
            listeners.forEach((listener) => {
                element.addEventListener(listener.type, listener.Function)
            });
        }
        return element
    }

    appendStyles = () => {
        const styleString = `
    
        .mobligo-fade-out-top{
        animation:fade-out 0.5s ease-in-out forwards
        }
        @keyframes fade-out-top{
            0%{transform:translateY(0px)}
            100%{transform:translateY(-100%)}
        }
        .mobligo-fade-out-bottom{
        animation:fade-out 0.5s ease-in-out forwards
        }
        @keyframes fade-out-bottom{
            0%{transform:translateY(0px)}
            100%{transform:translateY(100%)}
        }
        `
        const styleElement = this.createElement({ type: "style", attributes: { innerHTML: styleString, id: "mobligo-smart-banner-styles" } })
        this.element.appendChild(styleElement)
    }

    handleHideOnScroll = (event) => {
        const appData = this.appData
        const bannerLocation = appData?.data?.style?.bannerLocation
        const pushContent = appData?.data?.style?.pushContent

        const scrollTop = (this.scrollElement.scrollTop)
        const banner = document.querySelector("#mobligo-smart-banner-container")
        const height = banner.scrollHeight
        if (scrollTop > height * (pushContent ? 3 : 2)) {
            bannerLocation === "top" ? (banner.style.top = -height + "px") : (banner.style.bottom = -height + "px")
        } else {
            bannerLocation === "top" ? (banner.style.top = "0px") : (banner.style.bottom = "0px")

        }
    }

    addListeners = () => {
        const appData = this.appData
        const isFixed = appData?.data?.style?.isFixed
        const hideOnScroll = appData?.data?.style?.hideOnScroll
        if (hideOnScroll && isFixed) {

            this.scrollElement.addEventListener('scroll', this.handleHideOnScroll);
        }

    }

    renderElements = () => {
        const appData = this.appData
        const link = appData.iosLink
        const styles = appData?.data?.style || {
            "buttonColor": "#7059ef",
            "buttonTextColor": "#fff",
            "backgroundColor": "#000",
            "textColor": "#fff",
            "bannerLocation": "bottom",
            isFixed: false,
            hideOnScroll: false,
            pushContent: false
        }
        const isFixed = styles?.isFixed
        const pushContent = styles?.pushContent

        const closeButtonX = `
            <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 24 24" fill="none" stroke="${styles.textColor}" stroke-width="2px">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#0F1729"/>
    </svg>
    `
        const container = this.createElement({ type: "div", styles: { backgroundColor: styles.backgroundColor, width: "100%", position: isFixed ? "fixed" : "relative", display: "flex", flexDirection: "row", padding: "10px", top: styles?.bannerLocation === "top" ? 0 : "unset", bottom: styles?.bannerLocation === "bottom" ? 0 : "unset", left: 0, alignItems: "center", fontFamily: "sans-serif", zIndex: 2147483647, boxSizing: "border-box", transitionDuration: "0.3s" }, attributes: { id: "mobligo-smart-banner-container" } })
        const closeButton = this.createElement({
            type: "div", styles: { display: "flex", justifyContent: "center", alignItems: "center", padding: "10px", fontSize: "20px", cursor: "pointer" }, attributes: { innerHTML: closeButtonX }, listeners: [{
                type: "click", Function: () => {
                    localStorage.setItem("mobligo-smart-banner-settings", JSON.stringify({ exp: new Date().getTime() + 1000 * 60 * 24, isClosed: true }))
                    const banner = document.querySelector("#mobligo-smart-banner-container")
                    const bannerPlaceholder = document.querySelector("#mobligo-smart-banner-container-placeholder")
                    banner.remove()
                    bannerPlaceholder?.remove()

                }
            }]
        })
        const image = this.createElement({ type: "img", styles: { width: "50px", height: "50px", objectFit: "cover" }, attributes: { src: appData.appImg } })
        const textField = this.createElement({ type: "div", styles: { width: "auto", height: "auto", objectFit: "cover", display: "flex", flexDirection: "column", gap: "5px", padding: "10px" } })
        const title = this.createElement({ type: "div", styles: { fontSize: "16px", color: styles.textColor }, attributes: { innerHTML: appData.appName } })
        const desciption = this.createElement({ type: "div", styles: { fontSize: "12px", color: styles.textColor }, attributes: { innerHTML: appData.reference || "Created with mobligo" } })
        const button = this.createElement({ type: "div", styles: { objectFit: "cover", marginLeft: "auto", backgroundColor: styles.buttonColor, padding: "14px 16px", height: "7px", borderRadius: "30px", display: "flex", justifyContent: "center", alignItems: "center" }, listeners: [{ type: "click", Function: () => { window.location.href = link } }] })
        const buttonText = this.createElement({ type: "div", styles: { color: styles.buttonTextColor, fontSize: "14px", fontWeight: 600 }, attributes: { innerHTML: appData.buttonText || "Yükle" } })

        button.appendChild(buttonText)
        textField.appendChild(title)
        textField.appendChild(desciption)
        container.appendChild(closeButton)
        container.appendChild(image)
        container.appendChild(textField)
        container.appendChild(button)

        const renderElement = this.isFixed ? this.element : this.scrollElement
        if (renderElement.firstChild) {

            if (styles.bannerLocation === "top") {
                renderElement.insertBefore(container, renderElement.firstChild)

                if (pushContent && isFixed) {
                    const banner = document.querySelector("#mobligo-smart-banner-container")
                    const bannerHeight = banner?.scrollHeight
                    const placeholderContainer = this.createElement({ type: "div", styles: { height: bannerHeight + "px", backgroundColor: styles.backgroundColor, width: "100%", boxSizing: "border-box", padding: "0px 10px" }, attributes: { id: "mobligo-smart-banner-container-placeholder" } })
                    renderElement.insertBefore(placeholderContainer, renderElement.firstChild)
                }
            } else if (styles.bannerLocation === "bottom") {
                renderElement.appendChild(container, renderElement.firstChild)

            }

        } else {
            renderElement.appendChild(container)
        }
    }

    removeEventListener = () => {
        this.scrollElement.removeEventListener("scroll", this.handleHideOnScroll)
    }
    init = (appData, element, scrollElement) => {
        this.appData = appData
        this.element = element
        this.scrollElement = scrollElement
    }
}

const mobligoNew = new Mobligo()


const smartBannerRenderer = (appData, element, scrollElement) => {

    mobligoNew.init(appData, element, scrollElement)


    const container = document.querySelector("#mobligo-smart-banner-container")
    const containerPlaceholder = document.querySelector("#mobligo-smart-banner-container-placeholder")
    const containerStyle = document.querySelector("#mobligo-smart-banner-styles")

    container?.remove()
    containerPlaceholder?.remove()
    containerStyle?.remove()

    mobligoNew.removeEventListener()
    if (!appData?.data?.style) return

    if (appData.data.style.bannerLocation === "bottom") {
        appData.data.style = {
            ...appData.data.style,
            isFixed: true,
            pushContent: false
        }
    }

    mobligoNew.appendStyles()
    mobligoNew.renderElements()
    mobligoNew.addListeners()

}



export default smartBannerRenderer





